export const signUpInitialValues = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    location: '',
}
